import { terminationReasonOptions } from '@/constants/termination-reasons'
import { FileInput } from '@/shared/components/file-input'
import { useCreateRequestContractTerminationMutation } from '@/store/services/employee-contract.service'
import { Button, Input } from '@material-tailwind/react'
import { useFormik } from 'formik'
import { generatePath, useNavigate, useLocation } from 'react-router-dom'
import CustomSelect from '@/shared/components/custom-select'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

export const RequestContractTerminationForm = ({ currentEmployee }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = location.search

  const initialValues = {
    id: currentEmployee.activeContract.id,
    new_changes: {
      unlink_date: '',
      unlink_reason: ''
    }
  }

  const [createRequestContractTermination, { isSuccess, isLoading }] =
    useCreateRequestContractTerminationMutation()

  const { handleChange, values, setFieldValue, handleSubmit } = useFormik({
    initialValues,
    onSubmit: createRequestContractTermination
  })

  useEffect(() => {
    if (isSuccess) {
      navigate(`/employees${searchParams}`)
    }
  }, [isSuccess])

  return (
    <form className='flex flex-col gap-4 p-1' onSubmit={handleSubmit}>
      <Input
        name='new_changes.unlink_date'
        onChange={handleChange}
        value={values.new_changes.unlink_date}
        label='Fecha de desvinculación'
        type='date'
        required
      />

      <CustomSelect
        placeholder='Motivo de desvinculación'
        options={terminationReasonOptions}
        onChange={({ value }) =>
          setFieldValue('new_changes.unlink_reason', value)
        }
        menuPlacement='auto'
        menuPosition='fixed'
      />

      <FileInput
        text='Carga el documento asociado'
        handleChange={(file) => setFieldValue('attachment', file)}
        value={values.attachment}
      />

      <div className='flex justify-between'>
        <Button
          variant='text'
          color='gray'
          onClick={() => navigate(`/employees${searchParams}`)}
        >
          Cancelar
        </Button>

        <Button type='submit' loading={isLoading}>
          Enviar solicitud
        </Button>
      </div>
    </form>
  )
}

RequestContractTerminationForm.propTypes = {
  currentEmployee: PropTypes.object
}